/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 15th 2021, 10:14:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  APIMany2ManyCheckBoxFormInput,
  APIMany2ManyTransferListFormInput,
  ConcreteAPIMany2ManyTransferListFormInputProps,
} from "ui-widgets/forms";
import { WorkerAccount } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import ListItemText from "@mui/material/ListItemText";

export const WorkersCheckboxesInput = <T,>(props) => (
  <APIMany2ManyCheckBoxFormInput<T, WorkerAccount>
    apiServicePath={APISERVICEPATHS.workers}
    itemIdProperty="id"
    getOptionLabel={(option) => (
      <ListItemText
        primary={`${option.first_name + " " + option.last_name}`}
        secondary={`${option.email ? option.email : option.username}`}
      />
    )}
    {...props}
  />
);

export const WorkersTransferListInput = <T,>(
  props: ConcreteAPIMany2ManyTransferListFormInputProps<T, WorkerAccount>
) => (
  <APIMany2ManyTransferListFormInput<T, WorkerAccount>
    apiServicePath={APISERVICEPATHS.workers}
    itemIdProperty="id"
    getOptionLabel={(option) => (
      <ListItemText
        primary={`${option.first_name + " " + option.last_name}`}
        secondary={`${option.email ? option.email : option.username}`}
      />
    )}
    noDataMessage="Organization currently has no worker accounts. Invite workers to your organization to add them to a department."
    {...props}
  />
);
